import { updateUser } from '../../../../store/modules/profile'
import View from './ProfileForm'
import { compose } from 'ramda'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  error: state.profile.updateError,
  locale: state.router.locale,
  submitting: state.profile.isUpdating,
  success: state.profile.updateSuccess,
  user: state.profile.user,
})

const mapDispatchToProps = dispatch => ({
  submit: compose(dispatch, updateUser),
})

const ProfileForm = connect(mapStateToProps, mapDispatchToProps)(View)

export default ProfileForm
